import React, { useEffect, useState, useContext } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import SearchService from '../../../services/SearchService';
import { countyDefinition } from '../../../types/definitions/County';
import LoadingContext from './loading-context';
import SearchDataContext from '../../../providers/searchData-context';
import { Form } from 'react-bootstrap';

const CountyPicker: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const [countyList, setCountyList] = useState<countyDefinition[]>();
    const loadingCtx = useContext(LoadingContext);
    const searchDataCtx = useContext(SearchDataContext);

    const uid: string = authState.accessToken.claims?.uid;
    //const userName: string = authState.accessToken.claims?.sub;
    const accessToken: string = authState.accessToken.accessToken;

    useEffect(() => {
        if (!authState) return;

        setCountyList(undefined);

        if (searchDataCtx.state === '') {
            return;
        }

        loadingCtx.setIsLoading(true, 'CountyPicker');
        SearchService.getCounties(searchDataCtx.state, accessToken, uid)
            .then((response) => {
                setCountyList(response as countyDefinition[]);
                loadingCtx.setIsLoading(false, 'CountyPicker');
            })
            .catch((ex) => {
                //setError(ex.response);
                //setIsError(true);
                loadingCtx.setIsLoading(false, 'CountyPicker');
            });
    }, [searchDataCtx.state]);

    if (!authState) {
        return <div></div>;
    }

    const onChange = (e: any) => {
        const county = e.target.value;
        const selectedCounty =
            e.target.value != ''
                ? countyList?.filter((county) => county.code == e.target.value)[0]
                : undefined;
        const countyName = selectedCounty !== undefined ? selectedCounty.name : '';
        const countySupportedPlatform =
            selectedCounty !== undefined ? selectedCounty.supportedPlatform : '';
        searchDataCtx.setCounty(county, countyName, countySupportedPlatform);
    };

    const sortedCounties = countyList?.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });

    return (
        <>
            <label>County</label>
            <div className='col'>
                <Form.Control
                    tabIndex={2}
                    id='search-county'
                    className='form-select form-select-sm'
                    as='select'
                    required
                    onChange={onChange}
                    value={searchDataCtx.countyId}
                    name='county'
                >
                    <option value=''>Choose...</option>
                    {sortedCounties &&
                        sortedCounties.map((data) => (
                            <option key={data.code} value={data.code}>
                                {data.name}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                    Please choose your County
                </Form.Control.Feedback>
            </div>
        </>
    );
};

export default CountyPicker;
